import _ from "lodash";
import React from "react";
import Translate from "../../../../modules/local/Translate";
import {NullAsDefault} from 'views/Shared'
import {Avatar} from "antd";
import {ItemInformation} from "../../../AppLocals/Organization/OrganizationEntity";
import {CatholicHouseholdActionTypes} from "../../../AppLocals/CatholicHousehold/consts/CatholicHouseholdActionTypes";
import {BsCheckCircle, BsClock, BsXCircle} from "react-icons/bs";
import {renderIf} from "../../../Shared";
import classNames from "classnames";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {GoDotFill} from "react-icons/go";
import {formatDate} from "../../../../helpers/datetimeHelpers";

export const CatholicHouseholdStatus = {
    pending: {
        value: -1,
        label: 'pending',
        icon: <BsClock size={10}/>,
        className: 'text-blue-600',
    },
    approved: {
        value: 1,
        label: 'approved',
        icon: <BsCheckCircle size={10}/>,
        className: 'text-green-600',
    },
    rejected: {
        value: -2,
        label: 'rejected',
        icon: <BsXCircle size={10}/>,
        className: 'text-red-600',
    },
}

export const renderCatholicHousehold = ({actions, renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}) => (item, index) => {

    const {title, photo, source_idcode, eff_date, status, total} = item ?? {}
    const current_status = _.find(CatholicHouseholdStatus, {value: status}) ?? {}

    return (
        <LayoutContext.Consumer>
            {({isSm}) => (
                <Translate key={index}>
                    {(t) => (
                        <div key={index} className="flex gap-2 md:gap-3 rounded-lg custom-item-render custom-render-border relative">
                            {renderIf(
                                !isSm,
                                <Avatar
                                    size={100}
                                    src="/images/catholic-household-banner.webp"
                                    className="flex flex-center background-200 rounded-l-lg rounded-r-0 opacity-75"
                                />
                            )}
                            <div className="pl-1 md:pl-0 pr-2 py-2 flex flex-col flex-1">
                                <div
                                    onClick={() => {
                                        if (status !== 1) {
                                            handleAction(CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_APPROVE, item)
                                        } else {
                                            handleAction(CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_VIEW, item)
                                        }
                                    }}
                                    className="font-bold text-color-000 hover:text-primary cursor-pointer leading-snug mb-1">
                                    {`${t('catholic household')} ${title}`}
                                </div>
                                <div className="flex items-center gap-x-1 md:gap-x-4">
                                    <ItemInformation
                                        showIcon={true}
                                        label="number of households"
                                        value={!isSm ? source_idcode : `${source_idcode} - ${eff_date ? formatDate(eff_date, 'DD/MM/YYYY') : t('not update')}`}
                                        className="text-xs"/>
                                    {renderIf(
                                        !isSm,
                                        <ItemInformation
                                            showIcon={true}
                                            label="date of immigration"
                                            value={eff_date ? formatDate(eff_date, 'DD/MM/YYYY') : t('not update')}
                                            className="text-xs"/>
                                    )}
                                </div>
                                <div className="flex items-baseline gap-x-1 flex-wrap mt-0 md:mt-2">
                                    <GoDotFill size={11} className="text-green-600" />
                                    <span className="font-medium text-sm text-green-600 leading-snug tracking-wide">
                                        {t('family members')}
                                    </span>
                                    {renderIf(
                                        total.members > 0,
                                        <span style={{ fontSize: 11 }} className="font-bold text-green-500 leading-snug">
                                            {`( ${total.members} )`}
                                        </span>
                                    )}
                                    {renderIf(
                                        status === 1,
                                        <span
                                            onClick={() => (handleAction(CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_MEMBER, item))}
                                            className="pl-4 md:pl-8 text-xs text-color-500 hover:text-color-100 italic leading-tight cursor-pointer tracking-wide">
                                            {`...${t('view detail')}`}
                                        </span>
                                    )}
                                </div>
                            </div>
                            {renderIf(
                                status !== 1,
                                <span className={classNames("absolute right-5 bottom-5 font-medium text-2xs italic", current_status?.className)}>
                                    {t(current_status?.label)}
                                </span>
                            )}
                            {renderIf(
                                !!item?.edit && _.isFunction(renderContextMenu),
                                <div className="absolute right-5 top-5 flex gap-2 contextIcon">
                                    {actions}
                                    {renderContextMenu(item)}
                                </div>
                            )}
                        </div>
                    )}
                </Translate>
            )}
        </LayoutContext.Consumer>

    )
}